import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUsers, 
  faDollarSign, 
  faChartLine, // FontAwesome 5 no tiene faTrendingUp
  faArrowUp,
  faArrowDown
} from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';

const iconMap = {
  'kpi-leads': faUsers,
  'kpi-investment': faDollarSign,
  'kpi-roi': faChartLine
};

const colorMap = {
  'kpi-leads': 'primary',
  'kpi-investment': 'success',
  'kpi-roi': 'info'
};

/**
 * Widget KPI - Muestra métricas clave con animación
 */
const KPIWidget = ({ widget }) => {
  const [data, setData] = useState({
    value: 0,
    change: 0,
    trend: 'up',
    loading: true
  });

  useEffect(() => {
    loadData();
  }, [widget.type]);

  const loadData = async () => {
    // Simular carga de datos
    // TODO: Conectar con API real
    setTimeout(() => {
      const mockData = {
        'kpi-leads': { value: 1247, change: 12.5, trend: 'up' },
        'kpi-investment': { value: 48500, change: -3.2, trend: 'down' },
        'kpi-roi': { value: 287, change: 18.7, trend: 'up' }
      };

      setData({
        ...mockData[widget.type],
        loading: false
      });
    }, 500);
  };

  if (data.loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  const formatValue = (value) => {
    if (widget.type === 'kpi-investment') {
      return `$${value.toLocaleString()}`;
    }
    if (widget.type === 'kpi-roi') {
      return `${value}%`;
    }
    return value.toLocaleString();
  };

  return (
    <div className="kpi-widget text-center py-3">
      <div className={`kpi-icon mb-3 text-${colorMap[widget.type]}`}>
        <FontAwesomeIcon icon={iconMap[widget.type]} size="2x" />
      </div>
      
      <div className="kpi-value">
        <h2 className="mb-0">
          <CountUp 
            end={data.value} 
            duration={1.5}
            separator=","
            decimals={widget.type === 'kpi-roi' ? 1 : 0}
            prefix={widget.type === 'kpi-investment' ? '$' : ''}
            suffix={widget.type === 'kpi-roi' ? '%' : ''}
          />
        </h2>
      </div>

      <div className={`kpi-change mt-2 text-${data.trend === 'up' ? 'success' : 'danger'}`}>
        <FontAwesomeIcon 
          icon={data.trend === 'up' ? faArrowUp : faArrowDown} 
          className="me-1"
        />
        <span>{Math.abs(data.change)}%</span>
        <small className="text-muted ms-1">vs mes anterior</small>
      </div>
    </div>
  );
};

export default KPIWidget;

